import { ISettingsService } from "../typings/typings";

export class LeagueSignUpStatusService {
    public userGameAccount;
    public userTeams;
    public teamMembersWithGameAccounts;

    public static $inject = ["$resource", "SettingsService"];
    constructor(private $resource, private SettingsService: ISettingsService) {
        this.userGameAccount = this.$resource(this.SettingsService.eslapi_host + "/user/gameaccounts/:type/");
        this.userTeams = this.$resource(this.SettingsService.eslapi_host + "/user/teams");
        this.teamMembersWithGameAccounts = this.$resource(
            this.SettingsService.eslapi_host + "/teams/:id/members?exclude_roles=:exclude_roles&embed_gameaccount=:type"
        );
    }

    public userSettings(namespace, collection, key) {
        return this.$resource(
            this.SettingsService.eslapi_host + "/user/settings/:namespace/:collection/:key",
            {
                namespace: namespace,
                collection: collection,
                key: key,
            },
            {
                get: { method: "GET" },
                put: { method: "PUT" },
            }
        );
    }
}
